import { Card } from "antd";
import styled from "styled-components";

// Styled component for the card
const StyledCard = styled(Card)`
  padding: 30px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #fff;
  background-image: url(/invitation.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  height: 60vh;
  min-height: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export default StyledCard;
